import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { FiMenu, FiX } from "react-icons/fi";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [programsOpen, setProgramsOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setIsOpen(false);
    setProgramsOpen(false);
  }, [location.pathname, location.hash]);

  useEffect(() => {
    if (!isOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = prev;
    };
  }, [isOpen]);

  function closeMobile() {
    setIsOpen(false);
    setProgramsOpen(false);
  }

  function goToSection(sectionId) {
    closeMobile();
    navigate(`/#${sectionId}`);
  }

  function goProgramsWithFilters({ typeFilter, voucherAudienceFilter, statusFilter }) {
    const payload = { typeFilter, voucherAudienceFilter, statusFilter };

    sessionStorage.setItem("pendingProgramsFilters", JSON.stringify(payload));

    closeMobile();

    if (location.pathname !== "/") {
      navigate("/#programs");
      return;
    }

    window.dispatchEvent(
      new CustomEvent("programs:setFilters", {
        detail: payload,
      })
    );

    navigate("/#programs");
  }

  function handleProgramsClick(e, kind) {
    e.preventDefault();

    if (kind === "voucher") {
      goProgramsWithFilters({
        typeFilter: "voucher",
        voucherAudienceFilter: "unemployed",
        statusFilter: "all",
      });
      return;
    }

    if (kind === "selfFunded") {
      goProgramsWithFilters({
        typeFilter: "selfFunded",
        voucherAudienceFilter: "unemployed",
        statusFilter: "all",
      });
      return;
    }

    goToSection("programs");
  }

  return (
    <>
      <nav className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200">
        <div className="container mx-auto px-4">
          <div className="flex h-16 items-center justify-between">
            <Link to="/#top" className="flex items-center">
              <img src="/theseus.png" alt="ΘΗΣΕΑΣ" className="h-10 w-auto" />
            </Link>

            <div className="hidden md:flex items-center gap-6">
              <Link
                to="/#top"
                className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-semibold"
              >
                Αρχική
              </Link>

              <div className="relative group">
                <Link
                  to="/#programs"
                  className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-semibold inline-flex items-center gap-1"
                >
                  Προγράμματα <span className="text-xs">▼</span>
                </Link>

                <div className="absolute left-0 top-full h-3 w-72" />

                <div className="absolute left-0 top-full mt-0 w-72 rounded-xl border border-gray-200 bg-white shadow-lg opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto transition">
                  <div className="py-2">
                    <a
                      href="/#programs"
                      onClick={(e) => handleProgramsClick(e, "voucher")}
                      className="block px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50"
                    >
                      Voucher
                    </a>

                    <a
                      href="/#programs"
                      onClick={(e) => handleProgramsClick(e, "selfFunded")}
                      className="block px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50"
                    >
                      Αυτοχρηματοδοτούμενα
                    </a>

                    <Link
                      to="/#programs"
                      className="block px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50"
                    >
                      Άλλα επιδοτούμενα
                    </Link>

                    <Link
                      to="/clark"
                      className="block px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50"
                    >
                      Άδεια χειριστή ΚΛΑΡΚ
                    </Link>

                    <Link
                      to="/security"
                      className="block px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50"
                    >
                      Άδεια Security (ΙΕΠΥΑ)
                    </Link>
                  </div>
                </div>
              </div>

              <Link
                to="/#services"
                className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-semibold"
              >
                Υπηρεσίες
              </Link>

              <Link
                to="/faq"
                className="text-gray-700 hover:text-blue-600 px-3 py-2 text-sm font-semibold"
              >
                Ερωτήσεις
              </Link>

              <Link
                to="/contact"
                className="inline-flex items-center justify-center rounded-xl bg-blue-600 px-4 py-2 text-sm font-extrabold text-white hover:bg-blue-700"
              >
                Επικοινωνία
              </Link>
            </div>

            <button
              type="button"
              onClick={() => setIsOpen(true)}
              className="md:hidden inline-flex items-center justify-center rounded-xl border border-gray-300 bg-white px-3 py-2"
              aria-label="Άνοιγμα μενού"
            >
              <FiMenu size={20} />
            </button>
          </div>
        </div>
      </nav>

      {isOpen && (
        <div className="fixed inset-0 z-[9999] bg-white flex flex-col md:hidden">
          <div className="flex items-center justify-between px-4 py-4 border-b border-gray-200">
            <img src="/theseus.png" alt="ΘΗΣΕΑΣ" className="h-9 w-auto" />

            <button
              onClick={closeMobile}
              className="rounded-xl border border-gray-200 px-3 py-2"
              aria-label="Κλείσιμο"
              type="button"
            >
              <FiX size={18} />
            </button>
          </div>

          <div className="flex-1 overflow-y-auto p-4 space-y-3">
            <Link
              to="/#top"
              className="block rounded-xl px-4 py-3 font-semibold text-gray-800 hover:bg-gray-50"
              onClick={closeMobile}
            >
              Αρχική
            </Link>

            <div className="rounded-xl border border-gray-200 overflow-hidden">
              <button
                type="button"
                onClick={() => setProgramsOpen((v) => !v)}
                className="w-full flex items-center justify-between px-4 py-3 font-semibold text-gray-800 hover:bg-gray-50"
              >
                <span>Προγράμματα</span>
                <span>{programsOpen ? "▲" : "▼"}</span>
              </button>

              {programsOpen && (
                <div className="border-t border-gray-200">
                  <a
                    href="/#programs"
                    className="block px-6 py-3 text-sm font-semibold text-gray-700 hover:bg-gray-50"
                    onClick={(e) => handleProgramsClick(e, "voucher")}
                  >
                    Voucher
                  </a>

                  <a
                    href="/#programs"
                    className="block px-6 py-3 text-sm font-semibold text-gray-700 hover:bg-gray-50"
                    onClick={(e) => handleProgramsClick(e, "selfFunded")}
                  >
                    Αυτοχρηματοδοτούμενα
                  </a>

                  <Link
                    to="/#programs"
                    className="block px-6 py-3 text-sm font-semibold text-gray-700 hover:bg-gray-50"
                    onClick={closeMobile}
                  >
                    Άλλα επιδοτούμενα
                  </Link>

                  <Link
                    to="/clark"
                    className="block px-6 py-3 text-sm font-semibold text-gray-700 hover:bg-gray-50"
                    onClick={closeMobile}
                  >
                    Άδεια χειριστή ΚΛΑΡΚ
                  </Link>

                  <Link
                    to="/security"
                    className="block px-6 py-3 text-sm font-semibold text-gray-700 hover:bg-gray-50"
                    onClick={closeMobile}
                  >
                    Άδεια Security (ΙΕΠΥΑ)
                  </Link>
                </div>
              )}
            </div>

            <Link
              to="/#services"
              className="block rounded-xl px-4 py-3 font-semibold text-gray-800 hover:bg-gray-50"
              onClick={closeMobile}
            >
              Υπηρεσίες
            </Link>

            <Link
              to="/faq"
              className="block rounded-xl px-4 py-3 font-semibold text-gray-800 hover:bg-gray-50"
              onClick={closeMobile}
            >
              Ερωτήσεις
            </Link>

            <Link
              to="/contact"
              className="block rounded-2xl bg-blue-600 px-4 py-4 text-center font-extrabold text-white hover:bg-blue-700"
              onClick={closeMobile}
            >
              Επικοινωνία
            </Link>
          </div>
        </div>
      )}

      <div className="h-16" />
    </>
  );
}